import {
	SET_ACCOUNT_FRANCHISE_LIST,
	SET_FRANCHISE_MODELS,
	SET_SELECTED_FRANCHISE,
	SET_ACCOUNT_DATA,
	SET_ACCOUNT_THEME_KIT
} from './types';

export function setAccountData(accountData) {
	return {
		type: SET_ACCOUNT_DATA,
		payload: accountData
	};
}

export function setAccountFranchiseList(franchiseList) {
	return {
		type: SET_ACCOUNT_FRANCHISE_LIST,
		payload: franchiseList
	};
}

export function setFranchiseModels(franchiseModels) {
	return {
		type: SET_FRANCHISE_MODELS,
		payload: franchiseModels
	};
}
export function setSelectedFranchise(selectedFranchise) {
	return {
		type: SET_SELECTED_FRANCHISE,
		payload: selectedFranchise
	};
}
export function setAccountTheme(accountTheme) {
	return {
		type: SET_ACCOUNT_THEME_KIT,
		payload: accountTheme
	};
}
